// Currency formatting.

// Format it in the en-US locale rather than en-CA so that it explicitly
// adds "CAD" for clarity. Perhaps eventually detect browser locale.
export const Dollars = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "CAD",
});
